<template>
  <v-form v-if="isEditMode">
    <v-container>
      <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              ref="price"
              v-model="price"
              :rules="priceRules"
              required
              :append-icon="appendIconClasses"
              type="text"
              :append-icon-cb="handleSaveButtonClick"
            ></v-text-field>
          </v-flex>
      </v-layout>
    </v-container>
  </v-form>
  <v-form v-else>
    <v-container>
      <v-layout row wrap>
        <v-flex @click="handleEditPriceButtonClick" class="price" v-if="!item.hidden">
          <span v-if="item.price !== null">{{ item.price | currency }}</span>
          <span v-else>Set price</span>
        </v-flex>
        <v-flex v-else>
          <v-tooltip bottom>
            <i slot="activator" class="far fa-eye-slash"></i>
            <span>This service is hidden for client</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import api from '../../api'
import {showApiError} from '../../helpers/notification'
import {isNumeric} from '../../helpers/types'

export default {
  name: 'client-service-price',
  props: {
    item: Object
  },
  data () {
    return {
      appendIconClasses: 'fas fa-check save-icon',
      processing: false,
      isEditMode: false,
      draftPrice: this.item.price || this.item.defaultPrice,
      priceRules: [
        (value) => {
          let numeric = isNumeric(value)

          if (!numeric) {
            return 'Price must be numeric value'
          }

          if (parseFloat(value) < 0) {
            return 'Price value must be positive or zero'
          }

          return true
        }
      ]
    }
  },
  computed: {
    price: {
      get: function () {
        return this.item.price || this.item.defaultPrice
      },
      set: function (newValue) {
        this.draftPrice = newValue
      }
    }
  },
  methods: {
    handleEditPriceButtonClick () {
      this.isEditMode = !this.isEditMode
    },
    async handleSaveButtonClick () {
      if (!this.$refs.price.validate(true)) {
        return false
      }

      if (this.item.id) {
        try {
          let updatedItem = await api.updateClientService({
            id: this.item.id,
            price: parseFloat(this.draftPrice),
            currency: this.item.currency
          })
          this.$emit('updatedClientService', updatedItem)
        } catch (e) {
          showApiError(this, e, 'Unable to update client service')
          return
        }
      } else {
        try {
          let createdItem = await api.addServiceToClient({
            clientId: this.item.clientId,
            serviceId: this.item.serviceId,
            price: parseFloat(this.draftPrice),
            currency: this.item.currency
          })
          this.$emit('createdClientService', createdItem)
        } catch (e) {
          showApiError(this, e, 'Unable to add service to client')
          return
        }
      }

      this.isEditMode = false
    }
  }
}
</script>

<style>
  i {
    cursor: pointer;
  }
  .save-icon {
    color: #4caf50 !important;
  }

  .price {
    text-decoration: underline;
    cursor: pointer;
  }

  .price:hover {
    color: #1976d2;
  }

</style>



// WEBPACK FOOTER //
// src/components/Sales/ClientServicePrice.vue